<template>
  <div
    id="v-categories"
    class="categories-filter"
    v-if="!isLoading && isCreated"
    v-cloak
    ref="root"
  >
    <div class="categories-filter__back">
      <button
        class="c-btn c-btn--transparent has-icon"
        v-if="selectedCategoryId && showBackButton"
        @click.prevent="back"
        :title="backButtonName"
      >
        <i class="ico ico-arrow-left is-on-left"></i>
        <span>{{ backButtonName }}</span>
      </button>
    </div>

    <div class="categories-filter__list">
      <a
        v-for="category in categories"
        :href="category.link"
        :title="category.name"
        :class="{
          'c-link has-icon js-category-item': true,
          selected: category.id == selectedCategoryId,
        }"
        v-bind:key="category.id"
        @click.prevent="change(category.id)"
      >
        <div class="is-image">
          <img :src="thumbnail(category.image, 'navCategory')" alt="" />
        </div>

        <div class="is-name">
          <span>{{ category.name }}</span>
          <small class="hidden">(0)</small>
        </div>
      </a>
    </div>
  </div>

  <div
    id="v-categories"
    v-cloak
    class="categories-filter"
    v-else-if="isLoading && !isCreated"
  >
    <div class="categories-filter__list">
      <div
        v-for="(rootCategory, idx) in rootCategories"
        class="c-category-filter-skeleton"
        :key="idx"
      />
    </div>
  </div>

  <div
    id="v-categories"
    v-cloak
    class="categories-filter"
    v-else-if="isLoading && isCreated"
  >
    <div class="categories-filter__back">
      <button
        class="c-btn c-btn--transparent has-icon"
        v-if="selectedCategoryId && showBackButton"
        @click.prevent="back"
        :title="backButtonName"
      >
        <i class="ico ico-arrow-left is-on-left"></i>
        <span>{{ backButtonName }}</span>
      </button>
    </div>
    <div class="categories-filter__list">
      <div
        v-for="(_, idx) in categories"
        class="c-category-filter-skeleton"
        :key="idx"
      />
    </div>
  </div>
</template>

<script>
import CategoriesFilter from "FrontendComponents/CategoriesFilter";

export default {
  name: "CategoriesFilter",
  extends: CategoriesFilter,
  props: {
    rootCategories: {
      type: Array,
      required: true,
      default: new Array(8).fill(""),
    },
  },
  computed: {
    backButtonName() {
      if (!this.selectedCategory) {
        return "";
      }

      if (this.actualView == "siblings" && this.parent) {
        return this.parent.name;
      }

      return this.selectedCategory.name;
    },
  },
};
</script>
